var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tab',{attrs:{"title":_vm.translate('Time Events'),"active":_vm.active}},[_c('CategoryTimeEvents')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }